import { Routes } from "@angular/router";
import { SearchListComponent } from "./search-list/search-list.component";
import { ConsultaHistoricoComponent } from "./consulta-historico/consulta-historico.component";

export const consulta: Routes = [
  {
    path: "consulta",
    component: SearchListComponent,
  },
  {
    path: "historico/:idTema/:idEntrada",
    component: ConsultaHistoricoComponent,
  },
];
